import React from "react";
import MyBadge from "../MyBadge";
import MyIcon from "../MyIcon";
import XlsIcon from "../../../assets/icons/xls_files-01.svg2";
import TickIcon from "../../../assets/icons/tick.svg2";

export default function ContactsDataImportFound() {
  return (
    <div className=" align-items-center rounded-3 py-4 mt-4 ps-4 pe-5 bg-purple-gradient-darker-reverse m-3 fw-bold ">
      <div>
        <MyIcon Icon={XlsIcon} width={30} className="me-2" />
      </div>
      Data import found <MyBadge count={8} /> fields in the file:
      <div className="text-purple mt-2"> phone_contacts_data_import.xls</div>
      <div className="mt-3">
        <div
          className="overflow-auto d-flex flex-column p-3"
          style={{
            maxHeight: 200,
            scrollbarColor:
              "var(--color-dark-purple) rgba(var(--color-blue),0.1)",
          }}
        >
          <span className="d-flex align-items-center">
            <TickIcon width={15} />
            <h5 className=" p-1 small ms-2">First Name</h5>
          </span>
          <span className="d-flex align-items-center">
            <TickIcon width={15} />
            <h5 className=" p-1 small ms-2">Last Name</h5>
          </span>
          <span className="d-flex align-items-center">
            <TickIcon width={15} />
            <h5 className=" p-1 small ms-2">Company</h5>
          </span>
          <span className="d-flex align-items-center">
            <TickIcon width={15} />
            <h5 className=" p-1 small ms-2">Role</h5>
          </span>
          <span className="d-flex align-items-center">
            <TickIcon width={15} />
            <h5 className=" p-1 small ms-2">Telephone</h5>
          </span>{" "}
          <span className="d-flex align-items-center">
            <TickIcon width={15} />
            <h5 className=" p-1 small ms-2">Email</h5>
          </span>{" "}
          <span className="d-flex align-items-center">
            <TickIcon width={15} />
            <h5 className=" p-1 small ms-2">Location</h5>
          </span>
          <span className="d-flex align-items-center">
            <TickIcon width={15} />
            <h5 className=" p-1 small ms-2">Opt-in</h5>
          </span>
        </div>
      </div>
    </div>
  );
}
